import React from 'react';
import { IonCard, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonIcon } from '@ionic/react';
import useNavigation from '../hooks/useNavigation';
import { makeCall } from '../hooks/common';
import { personOutline, calendarOutline, call } from 'ionicons/icons';

interface IProps {
    referral: any;
}

const ReferralCard: React.FC<IProps> = (props) => {
    const navigateTo = useNavigation();

    return (
        <>
            <IonCard onClick={() => navigateTo('/tabs/referral', { referralId: props.referral.id })} style={{ margin: '8px', borderRadius: '12px' }}>
                {/* Header with Referral Name */}
                <IonItem style={{ '--background': 'transparent', '--border-color': 'transparent' }}>
                    <IonLabel>
                        <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: '0' }}>
                            {props.referral.name}
                        </h2>
                    </IonLabel>
                </IonItem>

                {/* Main Content Grid */}
                <IonGrid style={{ padding: '0 16px 16px 16px' }}>
                    <IonRow>
                        {/* Left Column - Contact Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Phone Number */}
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                                <IonIcon icon={call} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                <span 
                                    style={{ fontSize: '14px', cursor: 'pointer', color: '#3880ff' }}
                                    onClick={e => makeCall(e, props.referral.mobile)}
                                >
                                    {props.referral.mobile}
                                </span>
                            </div>

                            {/* Referred By */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <IonIcon icon={personOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                <span style={{ fontSize: '14px' }}>
                                    {props.referral?.Referrer?.name || props.referral?.referredBy || 'N/A'}
                                </span>
                            </div>
                        </IonCol>

                        {/* Right Column - Date Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Created Date */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <IonIcon icon={calendarOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                    {props.referral.created_date ? 
                                        new Intl.DateTimeFormat('en-GB', {
                                            month: 'short',
                                            day: '2-digit',
                                            year: 'numeric',
                                        }).format(new Date(props.referral.created_date)) 
                                        : 'N/A'
                                    }
                                </span>
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonCard>
        </>
    );
};

export default ReferralCard;
